__turbopack_export_value__({
  "body-logo-18": "ContactUs-module-scss-module__X2Lfva__body-logo-18",
  "body-text-12": "ContactUs-module-scss-module__X2Lfva__body-text-12",
  "body-text-14": "ContactUs-module-scss-module__X2Lfva__body-text-14",
  "body-text-16": "ContactUs-module-scss-module__X2Lfva__body-text-16",
  "body-text-18": "ContactUs-module-scss-module__X2Lfva__body-text-18",
  "body-text-20": "ContactUs-module-scss-module__X2Lfva__body-text-20",
  "body-text-24": "ContactUs-module-scss-module__X2Lfva__body-text-24",
  "body-text-24-2": "ContactUs-module-scss-module__X2Lfva__body-text-24-2",
  "body-text-heading-2": "ContactUs-module-scss-module__X2Lfva__body-text-heading-2",
  "body-text-heading-3": "ContactUs-module-scss-module__X2Lfva__body-text-heading-3",
  "body-text-medium-14": "ContactUs-module-scss-module__X2Lfva__body-text-medium-14",
  "body-text-medium-16": "ContactUs-module-scss-module__X2Lfva__body-text-medium-16",
  "body-text-medium-18": "ContactUs-module-scss-module__X2Lfva__body-text-medium-18",
  "body-text-medium2-18": "ContactUs-module-scss-module__X2Lfva__body-text-medium2-18",
  "body-text2-14": "ContactUs-module-scss-module__X2Lfva__body-text2-14",
  "body-text2-16": "ContactUs-module-scss-module__X2Lfva__body-text2-16",
  "button-primary-text": "ContactUs-module-scss-module__X2Lfva__button-primary-text",
  "button-text": "ContactUs-module-scss-module__X2Lfva__button-text",
  "button2-text": "ContactUs-module-scss-module__X2Lfva__button2-text",
  "card-shadow": "ContactUs-module-scss-module__X2Lfva__card-shadow",
  "contactUs": "ContactUs-module-scss-module__X2Lfva__contactUs",
  "contactUs__buttonWrapper": "ContactUs-module-scss-module__X2Lfva__contactUs__buttonWrapper",
  "contactUs__caption": "ContactUs-module-scss-module__X2Lfva__contactUs__caption",
  "contactUs__contactLink": "ContactUs-module-scss-module__X2Lfva__contactUs__contactLink",
  "contactUs__contacts": "ContactUs-module-scss-module__X2Lfva__contactUs__contacts",
  "contactUs__fields": "ContactUs-module-scss-module__X2Lfva__contactUs__fields",
  "contactUs__form": "ContactUs-module-scss-module__X2Lfva__contactUs__form",
  "contactUs__info": "ContactUs-module-scss-module__X2Lfva__contactUs__info",
  "effect-menu": "ContactUs-module-scss-module__X2Lfva__effect-menu",
  "header-1": "ContactUs-module-scss-module__X2Lfva__header-1",
  "main-container": "ContactUs-module-scss-module__X2Lfva__main-container",
  "main-footer-container": "ContactUs-module-scss-module__X2Lfva__main-footer-container",
  "main-header-container": "ContactUs-module-scss-module__X2Lfva__main-header-container",
  "txt-12-bold": "ContactUs-module-scss-module__X2Lfva__txt-12-bold",
  "txt-14-bold": "ContactUs-module-scss-module__X2Lfva__txt-14-bold",
  "txt-14-bold-caps": "ContactUs-module-scss-module__X2Lfva__txt-14-bold-caps",
  "txt-14-med": "ContactUs-module-scss-module__X2Lfva__txt-14-med",
  "txt-16-bold": "ContactUs-module-scss-module__X2Lfva__txt-16-bold",
  "txt-16-med": "ContactUs-module-scss-module__X2Lfva__txt-16-med",
  "txt-18-bold": "ContactUs-module-scss-module__X2Lfva__txt-18-bold",
  "txt-18-medium": "ContactUs-module-scss-module__X2Lfva__txt-18-medium",
  "txt-18-medium-24": "ContactUs-module-scss-module__X2Lfva__txt-18-medium-24",
  "txt-24-semi": "ContactUs-module-scss-module__X2Lfva__txt-24-semi",
});
